import "./hero.css";
import Shoes from "../../assets/shoes.png";
import { Link } from "react-router-dom";

const Hero = () => {
  const video = require("../../assets/Shoes.mp4");
  return (
    <div className="hero">
      <div className="hero-video">
        <video autoPlay loop muted width="100%">
          
          <source src={video} type="video/mp4" />
        </video>
      </div>
      <div className="hero-frame">
        <Link to="/products">
        <img src={Shoes} alt="hero" /></Link>
      </div>
      <div className="hero-text">
        <h3>Welcome to</h3>
        <h1>Shoe <span>Villa</span></h1>
        <Link to="/products"><p className="hero-start">Game Begins<span /></p></Link>
      </div>
    </div>
  );
};
export default Hero;